<script setup>
import 'shared/assets/styles/talkvia-loading.css';
import LoadingMessages from 'shared/components/LoadingMessages.vue';

defineProps({
  showMessage: { type: Boolean, default: true },
  size: {
    type: Number,
    default: 24,
  },
});
const loadingLabel = 'Carregando';
</script>

<template>
  <span
    class="inline-flex flex-col items-center justify-center gap-1 align-middle"
    role="status"
    :aria-label="loadingLabel"
  >
    <span
      class="i-hugeicons-loading-03"
      :style="{ width: `${size}px`, height: `${size}px` }"
      aria-hidden="true"
    />
    <LoadingMessages v-if="showMessage" class="text-n-slate-11" />
  </span>
</template>
